import { render, staticRenderFns } from "./format-icons.vue?vue&type=template&id=3ac3b336&scoped=true"
import script from "./format-icons.vue?vue&type=script&lang=js"
export * from "./format-icons.vue?vue&type=script&lang=js"
import style0 from "./format-icons.vue?vue&type=style&index=0&id=3ac3b336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3b336",
  null
  
)

export default component.exports